const STYLES = {
  pending: "bg-amber-100 text-amber-800 border-amber-200",
  "pending verification": "bg-amber-100 text-amber-800 border-amber-200",
  verified: "bg-green-100 text-green-800 border-green-200",
  rejected: "bg-red-100 text-red-800 border-red-200",
  active: "bg-green-100 text-green-800 border-green-200",
  paused: "bg-slate-100 text-slate-700 border-slate-200",
  completed: "bg-blue-100 text-blue-800 border-blue-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
  processing: "bg-sky-100 text-sky-800 border-sky-200",
  paid: "bg-green-100 text-green-800 border-green-200",
  available: "bg-green-100 text-green-800 border-green-200",
  suspended: "bg-red-100 text-red-800 border-red-200",
  adjusted: "bg-violet-100 text-violet-800 border-violet-200",
  open: "bg-sky-100 text-sky-800 border-sky-200",
  resolved: "bg-green-100 text-green-800 border-green-200",
};

const LABELS = { pending: "Pending", verified: "Verified", rejected: "Rejected", active: "Active", paused: "Paused", completed: "Completed", expired: "Expired", processing: "Processing", paid: "Paid", available: "Credited", suspended: "Suspended", adjusted: "Adjusted", open: "Open", resolved: "Resolved" };

export function StatusBadge({ status, testid }) {
  const key = (status || "").toLowerCase();
  return (
    <span data-testid={testid || `status-badge-${key}`} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${STYLES[key] || "bg-slate-100 text-slate-700 border-slate-200"}`}>
      {LABELS[key] || status}
    </span>
  );
}
